import { Functionality } from "web/types/Employee";
import { IUrlFunctionalityMenuItem, MenuItemType } from "web/types/Menu";

import { MenuItemContext, ProcessedMenuItem } from "./types";

const handleUrlFunctionalityMenuItem = (
  menuItem: IUrlFunctionalityMenuItem,
  context: MenuItemContext
): ProcessedMenuItem | null => {
  const { functionalities, msiCartsEnabledSelector, isEn } = context;

  const funcFromEmployee = functionalities?.find(
    (func) => func === menuItem.url_functionality
  );

  if (
    funcFromEmployee &&
    (funcFromEmployee !== Functionality.ENABLE_MSI_CARDS ||
      (funcFromEmployee === Functionality.ENABLE_MSI_CARDS &&
        msiCartsEnabledSelector))
  ) {
    return {
      type: MenuItemType.URL_FUNCTIONALITY,
      code: menuItem.code,
      title: menuItem.title,
      url: isEn ? menuItem.url_en : menuItem.url,
    };
  }

  return null;
};

export default handleUrlFunctionalityMenuItem;
